import {
  DELETE_CLOTH_QUALITY,
  ADD_CLOTH_QUALITY,
  GET_CLOTH_QUALITY,
  EDIT_CLOTH_QUALITY,
} from "../Types";
const initialState = {
  clothQuality: [],
};

function clothQualityReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_CLOTH_QUALITY: {
      return {
        ...state,
        clothQuality: [...state.clothQuality, action.payload],
      };
    }
    case GET_CLOTH_QUALITY: {
      const totalClothQualities = action.payload;
      return { ...state, clothQuality: totalClothQualities };
    }
    case EDIT_CLOTH_QUALITY: {
      let UpdatedClothQuality = state.clothQuality.map((item) =>
        item.cloth_quality_id === action.payload.cloth_quality_id
          ? action.payload
          : item
      );
      return {
        ...state,
        clothQuality: UpdatedClothQuality,
      };
    }
    case DELETE_CLOTH_QUALITY: {
      const after_delete_clothQuality = state.clothQuality.filter(
        (clothQuality) =>
          clothQuality.cloth_quality_id !== action.payload.cloth_quality_id
      );
      console.log(after_delete_clothQuality);
      return { ...state, clothQuality: after_delete_clothQuality };
    }
    default:
      return state;
  }
}

export default clothQualityReducer;
